<template>
  <div id="app">
    <notification />
<!--    <component :is="mainComponent">-->
      <router-view/>
<!--    </component>-->
    <loading :active.sync="getLoading" :can-cancel="canCancel" :is-full-page="fullPage">
      <svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" width="64" height="64" stroke="#000"><g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="2"><circle stroke-opacity=".25" cx="18" cy="18" r="18"></circle><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.8s" repeatCount="indefinite"></animateTransform></path></g></g></svg>
    </loading>
  </div>
</template>

<script>
import CustomLayoutV2 from './layout/CustomLayout'
import DashboardLayout from './layout/DashboardLayout'
import NoLayout from './layout/NoLayout'
import Notification from './components/common/Notification'
import Loading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'

import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'App',
  components: {
    NoLayout,
    Notification,
    Loading,
    CustomLayoutV2
  },
  computed: {
    ...mapGetters(['getLoading'])
  },
  data () {
    return {
      mainComponent: DashboardLayout,
      isLoading: true,
      canCancel: false,
      fullPage: true
    }
  },
  watch: {
    $route (to) {
      switch (to.path) {
        default:
          this.mainComponent = DashboardLayout
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Roboto', sans-serif;
  min-width: 375px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue